import React from "react";
import AuthMarketingPanel from "./AuthMarketingPanel";
import AuthShellNavbar from "./AuthShellNavbar";
import { useAuthPageChrome } from "./useAuthPageChrome";
import "./AuthPages.scss";

type AuthSplitShellProps = {
  children: React.ReactNode;
};

/** Login/register chrome: white panel + navbar + marketing panel + entrance. */
const AuthSplitShell: React.FC<AuthSplitShellProps> = ({ children }) => {
  const { triggerZoomOut, zoom, zoomProps, anim, variant, pageClassName } =
    useAuthPageChrome({ entrance: true });

  return (
    <>
      <div className={pageClassName("auth-split-page")} style={zoomProps}>
        <div className="auth-panel">
          <div className="auth-panel__surface" aria-hidden="true" />
          <AuthShellNavbar
            anim={anim}
            variant={variant}
            triggerZoomOut={triggerZoomOut}
          />
          <div className="auth-panel__body">
            <div className="auth-panel__form">{children}</div>
          </div>
        </div>
        <AuthMarketingPanel />
      </div>
      {zoom && <div className="auth-zoom-bg" />}
    </>
  );
};

export default AuthSplitShell;
